const messages = {
  title: "Bonusmultiplicator",
  bandBonusTitle: "Bonus per band na multiplicator",
  amountLabel: "Min. aantal banden (*)",
  label: "Multiplicator bonus",
  desc: "Aantal Bridgestone- en Firestone banden. Er is geen bonus in euro op Firestone banden.",
  goals: {
    loyal: "Loyal",
    bronze: "Brons",
    silver: "Zilver",
    gold: "Goud",
    platinum: "Platina",
  },
  andMore: "en meer",
  chooseTarget: "Selecteer",
  selectTarget: "Selecteer hier uw jaardoelstelling {year}:",
  multiplication: "Bonus wordt met <b>{factor} vermenigvuldigd</b>",
  minTyres: "<b>Minimaal:</b> {tyre} banden",
};

export default {
  messages,
};
